import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    maxLists: 10,
    showEcoFee: true,
    enableEnergyLabelLink: true,
};
